import { render, staticRenderFns } from "./SpeakerEditTabSocial.vue?vue&type=template&id=d6ae128c&"
import script from "./SpeakerEditTabSocial.vue?vue&type=script&lang=js&"
export * from "./SpeakerEditTabSocial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports